/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtServiceAdministrator.id.label': '主键',
'tqtServiceAdministrator.id.holder': '请输入主键',
'tqtServiceAdministrator.id.max': '主键最多11个字符',
'tqtServiceAdministrator.id.required': '主键必填',
'tqtServiceAdministrator.searchId.holder': '搜索主键',
'tqtServiceAdministrator.userid.label': '用户id',
'tqtServiceAdministrator.userid.holder': '请输入用户id',
'tqtServiceAdministrator.userid.max': '用户id最多11个字符',
'tqtServiceAdministrator.userid.required': '用户id必填',
'tqtServiceAdministrator.searchUserid.holder': '搜索用户id',
'tqtServiceAdministrator.type.label': '0驻厂员，1服务专员',
'tqtServiceAdministrator.type.holder': '请输入0驻厂员，1服务专员',
'tqtServiceAdministrator.type.max': '0驻厂员，1服务专员最多1个字符',
'tqtServiceAdministrator.type.required': '0驻厂员，1服务专员必填',
'tqtServiceAdministrator.searchType.holder': '搜索0驻厂员，1服务专员',
'tqtServiceAdministrator.deptname.label': '部门名称',
'tqtServiceAdministrator.deptname.holder': '请输入部门名称',
'tqtServiceAdministrator.deptname.max': '部门名称最多18个字符',
'tqtServiceAdministrator.deptname.required': '部门名称必填',
'tqtServiceAdministrator.searchDeptname.holder': '搜索部门名称',
'tqtServiceAdministrator.duty.label': '职位',
'tqtServiceAdministrator.duty.holder': '请输入职位',
'tqtServiceAdministrator.duty.max': '职位最多18个字符',
'tqtServiceAdministrator.duty.required': '职位必填',
'tqtServiceAdministrator.searchDuty.holder': '搜索职位',
'tqtServiceAdministrator.area.label': '所属区名称',
'tqtServiceAdministrator.area.holder': '请输入所属区名称',
'tqtServiceAdministrator.area.max': '所属区名称最多18个字符',
'tqtServiceAdministrator.area.required': '所属区名称必填',
'tqtServiceAdministrator.searchArea.holder': '搜索所属区名称',
'tqtServiceAdministrator.companyid.label': '企业id',
'tqtServiceAdministrator.companyid.holder': '请输入企业id',
'tqtServiceAdministrator.companyid.max': '企业id最多11个字符',
'tqtServiceAdministrator.companyid.required': '企业id必填',
'tqtServiceAdministrator.searchCompanyid.holder': '搜索企业id',
},
'zh-TW': {
'tqtServiceAdministrator.id.label': '主键',
'tqtServiceAdministrator.id.holder': '請輸入主键',
'tqtServiceAdministrator.id.max': '主键最多11個字符',
'tqtServiceAdministrator.id.required': '主键必填',
'tqtServiceAdministrator.searchId.holder': '搜索主键',
'tqtServiceAdministrator.userid.label': '用户id',
'tqtServiceAdministrator.userid.holder': '請輸入用户id',
'tqtServiceAdministrator.userid.max': '用户id最多11個字符',
'tqtServiceAdministrator.userid.required': '用户id必填',
'tqtServiceAdministrator.searchUserid.holder': '搜索用户id',
'tqtServiceAdministrator.type.label': '0驻厂员，1服务专员',
'tqtServiceAdministrator.type.holder': '請輸入0驻厂员，1服务专员',
'tqtServiceAdministrator.type.max': '0驻厂员，1服务专员最多1個字符',
'tqtServiceAdministrator.type.required': '0驻厂员，1服务专员必填',
'tqtServiceAdministrator.searchType.holder': '搜索0驻厂员，1服务专员',
'tqtServiceAdministrator.deptname.label': '部门名称',
'tqtServiceAdministrator.deptname.holder': '請輸入部门名称',
'tqtServiceAdministrator.deptname.max': '部门名称最多18個字符',
'tqtServiceAdministrator.deptname.required': '部门名称必填',
'tqtServiceAdministrator.searchDeptname.holder': '搜索部门名称',
'tqtServiceAdministrator.duty.label': '职位',
'tqtServiceAdministrator.duty.holder': '請輸入职位',
'tqtServiceAdministrator.duty.max': '职位最多18個字符',
'tqtServiceAdministrator.duty.required': '职位必填',
'tqtServiceAdministrator.searchDuty.holder': '搜索职位',
'tqtServiceAdministrator.area.label': '所属区名称',
'tqtServiceAdministrator.area.holder': '請輸入所属区名称',
'tqtServiceAdministrator.area.max': '所属区名称最多18個字符',
'tqtServiceAdministrator.area.required': '所属区名称必填',
'tqtServiceAdministrator.searchArea.holder': '搜索所属区名称',
'tqtServiceAdministrator.companyid.label': '企业id',
'tqtServiceAdministrator.companyid.holder': '請輸入企业id',
'tqtServiceAdministrator.companyid.max': '企业id最多11個字符',
'tqtServiceAdministrator.companyid.required': '企业id必填',
'tqtServiceAdministrator.searchCompanyid.holder': '搜索企业id',
},
'en-US': {
'tqtServiceAdministrator.id.label': '主键',
'tqtServiceAdministrator.id.holder': 'Enter 主键',
'tqtServiceAdministrator.id.max': '主键 max length: 11',
'tqtServiceAdministrator.id.required': '主键 required',
'tqtServiceAdministrator.searchId.holder': 'Search 主键',
'tqtServiceAdministrator.userid.label': '用户id',
'tqtServiceAdministrator.userid.holder': 'Enter 用户id',
'tqtServiceAdministrator.userid.max': '用户id max length: 11',
'tqtServiceAdministrator.userid.required': '用户id required',
'tqtServiceAdministrator.searchUserid.holder': 'Search 用户id',
'tqtServiceAdministrator.type.label': '0驻厂员，1服务专员',
'tqtServiceAdministrator.type.holder': 'Enter 0驻厂员，1服务专员',
'tqtServiceAdministrator.type.max': '0驻厂员，1服务专员 max length: 1',
'tqtServiceAdministrator.type.required': '0驻厂员，1服务专员 required',
'tqtServiceAdministrator.searchType.holder': 'Search 0驻厂员，1服务专员',
'tqtServiceAdministrator.deptname.label': '部门名称',
'tqtServiceAdministrator.deptname.holder': 'Enter 部门名称',
'tqtServiceAdministrator.deptname.max': '部门名称 max length: 18',
'tqtServiceAdministrator.deptname.required': '部门名称 required',
'tqtServiceAdministrator.searchDeptname.holder': 'Search 部门名称',
'tqtServiceAdministrator.duty.label': '职位',
'tqtServiceAdministrator.duty.holder': 'Enter 职位',
'tqtServiceAdministrator.duty.max': '职位 max length: 18',
'tqtServiceAdministrator.duty.required': '职位 required',
'tqtServiceAdministrator.searchDuty.holder': 'Search 职位',
'tqtServiceAdministrator.area.label': '所属区名称',
'tqtServiceAdministrator.area.holder': 'Enter 所属区名称',
'tqtServiceAdministrator.area.max': '所属区名称 max length: 18',
'tqtServiceAdministrator.area.required': '所属区名称 required',
'tqtServiceAdministrator.searchArea.holder': 'Search 所属区名称',
'tqtServiceAdministrator.companyid.label': '企业id',
'tqtServiceAdministrator.companyid.holder': 'Enter 企业id',
'tqtServiceAdministrator.companyid.max': '企业id max length: 11',
'tqtServiceAdministrator.companyid.required': '企业id required',
'tqtServiceAdministrator.searchCompanyid.holder': 'Search 企业id',
}
};